<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tp01">
<a id="page03"></a>
<h2 class="titlePageTitle">My Soul to Take</h2>
<p class="titlePageSubtitle">A Novel of Iceland</p>
<h2 class="titlePageAuthor">Yrsa Sigurdardóttir</h2>
<p class="titlePageText">Translated from the Icelandic by Bernard Scudder and Anna Yates</p>
<p class="colophon"><img alt="image" src="Images/logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mysoultotake_tp01.vue?778fa564